import { render, staticRenderFns } from "./TicketDuration.vue?vue&type=template&id=398d2468&scoped=true"
import script from "./TicketDuration.vue?vue&type=script&lang=js"
export * from "./TicketDuration.vue?vue&type=script&lang=js"
import style0 from "./TicketDuration.vue?vue&type=style&index=0&id=398d2468&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398d2468",
  null
  
)

export default component.exports